import { withSentryReactRouterV7Routing } from "@sentry/react";
import { Routes, Route } from "react-router";
import { apiClient } from "./client";
import { StatementSurveyWrapper } from "./components/statement";
import { ChooseTheme } from "./components/choose_theme";
import { createContext } from "react";
import translate from "./locales";

export const SentryRoutes = withSentryReactRouterV7Routing(Routes);
export const LocaleContext = createContext({});

export default function App({ locale }) {
  function translateWithLocale(key, interpolations, specifiedLocale = locale) {
    return translate(key, interpolations, specifiedLocale);
  }

  return (
    <LocaleContext value={{ locale, translate: translateWithLocale }}>
      <SentryRoutes>
        <Route path="/" element={<ChooseTheme />} />
        <Route
          path="/:statement"
          element={<StatementSurveyWrapper apiClient={apiClient} />}
        />
      </SentryRoutes>
    </LocaleContext>
  );
}
